import type { GridSortModel } from '@mui/x-data-grid-pro'
import type { SetActivitySummaryOrderByAction } from './typings'

export const setActivitySummaryOrderByActionCreator = (
  payload?: GridSortModel,
): SetActivitySummaryOrderByAction => ({
  type: 'activitySummary/setOrderBy',
  payload,
})
